import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { PageFooter } from 'features/reporting/pdfGeneration/components/shared/PageFooter'
import { PageHeader } from 'features/reporting/pdfGeneration/components/shared/PageHeader'
import { ReportPage } from 'features/reporting/pdfGeneration/components/shared/ReportPage'
import { PdfProps } from 'features/reporting/types'
import { ImagePageHeader } from 'pages/reporting/reports/rug/components/ImagePageHeader'
import { SectionAddendum } from 'pages/reporting/reports/rug/rugReportData'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'

interface CustomSectionPagesProps extends PdfProps {
  sectionId: string
  sectionTitle: string
  addendums: SectionAddendum[]
}

const pageStyles = StyleSheet.create({
  customSectionPage: {
    minHeight: '100%',
  },
})

/**
 * Component to render custom section pages
 * These are for entirely new sections that don't match existing report sections
 */
export const CustomSectionPages: React.FC<CustomSectionPagesProps> = ({
  sectionId,
  sectionTitle,
  addendums,
  onRender,
}) => {
  const { formData } = useRugReportOps()

  if (addendums.length === 0) {
    return null
  }

  return (
    <>
      {addendums.map((addendum, addendumIndex) =>
        Array.from({ length: addendum.addedPageCount }).map((_, pageIndex) => {
          // Only track the page number on the first page of the first addendum for this section
          const shouldTrack = addendumIndex === 0 && pageIndex === 0

          return (
            <ReportPage
              key={`${addendumIndex}-${pageIndex}`}
              size='LETTER'
              orientation='landscape'
              pageStyle={pageStyles.customSectionPage}
              tracker={shouldTrack ? { sectionId, onRender } : undefined}
              header={<PageHeader title={sectionTitle} />}
              footer={
                <PageFooter
                  jobNumber={formData.mainInfo.assetId}
                  revisionNumber={formData.revisionMetadata.revisionNumber}
                />
              }>
              <ImagePageHeader />
              {addendum.pageSubtitle && (
                <View style={{ marginBottom: 8 }}>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: 'bold',
                      color: '#2e5266',
                    }}>
                    {addendum.pageSubtitle}
                  </Text>
                </View>
              )}
            </ReportPage>
          )
        })
      )}
    </>
  )
}
